import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import TasksCol from "../../../components/HomeColumns/TasksCol";
import StatisticsWrapper from "../../../components/statisticsWrapper/StatisticsWrapper";
import { requestStatisticsRequest } from "../../../store/dashboard/actions";
import { usersIcon } from "../../../utils/images";
import { programsIcon } from "../../../utils/images";
import { labTests } from "../../../utils/images";
import { refLabs } from "../../../utils/images";
import './home.scss';
import moment from 'moment';
import { getAppointmentsListRequest, getAppointmentsStatisticsRequest, getReceptionistAppointmentsListRequest } from "../../../store/appointments/actions";
import Calendar from "./Calendar";
import MyTodayAppointments from "./MyTodayAppointments";
import AppointmentsStatisticsWrapper from "../../../components/AppointmentsStatisticsWrapper/AppointmentsStatisticsWrapper";
import NextAppointment from "./NextAppointment";
import SpecialistAppointments from "./SpecialistAppointments";
import ReceptionistApps from "./ReceptionistApps";
import AddAppointmentForm from "./AddAppointmentForm";
import Agencies from "../../Agencies";

const Home = ({ intl: { messages } }) => {
  const history = useHistory();
  const { requestStatistics } = useSelector((state) => state?.dashboard);
  const token = useSelector((state) => state.auth?.token?.token) || localStorage.getItem("token");
  const user = useSelector((state) => state.auth?.user?.data);
  const { appointmentsList, appointmentsStatistics, receptionistAppsList } = useSelector((state) => state.appointments);
  const [selectedAppsDate, setSelectedAppsDate] = useState(moment().format("YYYY-MM-DD"));
  const [showAppsForm, setShowAppsForm] = useState(false);
  const [showReceptionistAppsForm, setShowReceptionistAppsForm] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const dispatch = useDispatch();
  const roleId = parseInt(localStorage.getItem("role"));

  //console.log("check auto deploy");

  useEffect(() => {
    if (token && user) {
      if (user?.role_id !== 7 && user?.role_id !== 8) {
        if (user?.role_id === 4 || user?.role_id === 6) {
          dispatch(getAppointmentsStatisticsRequest());
        } else {
          dispatch(requestStatisticsRequest());
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, user]);

   useEffect(() => {
     if (user?.role_id === 4 || user?.role_id === 6) {
      dispatch(getAppointmentsListRequest({
          user_id: user.id,
          start_date: moment(selectedAppsDate, 'YYYY-MM-DD').subtract(5, 'days').format('YYYY-MM-DD'),
          end_date: moment(selectedAppsDate, 'YYYY-MM-DD').add(5, 'days').format('YYYY-MM-DD')
      }));
     } else if (user?.role_id === 2) {
        dispatch(getReceptionistAppointmentsListRequest({
          user_id: null,
          start_date: moment(selectedAppsDate, 'YYYY-MM-DD').subtract(5, 'days').format('YYYY-MM-DD'),
          end_date: moment(selectedAppsDate, 'YYYY-MM-DD').add(5, 'days').format('YYYY-MM-DD')
        }));
     }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    useEffect(() => {
      if (appointmentsList?.appointments?.length > 0) {
        var sd = [];
        appointmentsList.appointments?.forEach(item => {
          if (!sd.includes(moment(item.startDate).format('YYYY-MM-DD'))) {
            sd.push(moment(item.startDate).format('YYYY-MM-DD'));
          }
        });
        setSelectedDates(sd);
        setSelectedAppsDate(moment(appointmentsList?.appointments[0]?.startDate).format('YYYY-MM-DD'));
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentsList]);

    useEffect(() => {
      if (receptionistAppsList?.appointments?.length > 0) {
        var sd = [];
        receptionistAppsList.appointments?.forEach(item => {
          if (moment(item.startDate).diff(moment()) && !sd.includes(moment(item.startDate).format('YYYY-MM-DD'))) {
            sd.push(moment(item.startDate).format('YYYY-MM-DD'));
          }
        });
        setSelectedDates(sd);
        setSelectedAppsDate(moment(receptionistAppsList?.appointments[0]?.startDate).format('YYYY-MM-DD'));
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [receptionistAppsList]);

    const handleRedirect = (route) => {
      history.push(route);
    };

    if (roleId === 7 || roleId === 8) {
      return <Agencies />
    }

    return (
      <section className="home-wrapper">
          {user?.role_id === 4 || user?.role_id === 6 ? <AppointmentsStatisticsWrapper statistics={appointmentsStatistics} /> : <StatisticsWrapper statistics={requestStatistics} />}
        {
          user?.role_id === 1 ? (
            <>
                <div className="home-container">
                    <div className="home-col">
                      <TasksCol />
                    </div>
                    <div className="home-col">
                        <div className="adminBtn" onClick={() => handleRedirect("/users")}>
                          <span>{messages.home.system_accounts}</span>
                          <img src={usersIcon} alt="users" />
                        </div>
                        <div className="adminBtn" onClick={() => handleRedirect("/lab-tests")}>
                          <span>{messages.home.lab_tests}</span>
                          <img src={labTests} alt="labtest" />
                        </div>
                        <div className="adminBtn" onClick={() => handleRedirect("/reference-labs")}>
                          <span>{messages.home.ref_labs}</span>
                          <img src={refLabs} alt="reflabs" />
                        </div>
                        <div className="adminBtn" onClick={() => handleRedirect("/programs")}>
                          <span>{messages.home.programs_subscription}</span>
                          <img src={programsIcon} alt="programs" />
                        </div>
                    </div>
                    <div className="home-col">
                        <SpecialistAppointments />
                    </div>
                </div>
            </>
          ) : user?.role_id === 2  ? (
            <>
                <div className="home-container">
                    <div className="home-col">
                      <TasksCol />
                    </div>
                    <div className="home-col calendar-container userform_container">
                      <div className="calendar">
                        <Calendar mydate={selectedAppsDate} dates={selectedDates} />
                        <button className="homeBtn calendar-show" onClick={() => setShowReceptionistAppsForm(true)} >{messages.buttons.details}</button>
                        <ReceptionistApps show={showReceptionistAppsForm} close={() => {setShowReceptionistAppsForm(false)}} userId={user?.id} selectedApp={null} />
                      </div>
                    </div>
                    <div className="home-col">
                        <SpecialistAppointments />
                    </div>
                </div>
            </>
          ) : user?.role_id === 4 || user?.role_id === 6 ? (
            <>
                <div className="home-container">
                    <div className="home-col">
                      <div className="adminBtn" onClick={() => handleRedirect("/myPatients")}>
                          <span>{messages.home.patients_list}</span>
                          <img src={usersIcon} alt="users" />
                      </div>
                      <TasksCol />
                    </div>
                    <div className="home-col">
                      <div className="adminBtn" onClick={() => handleRedirect("/lab-tests")}>
                          <span>{messages.home.lab_tests}</span>
                          <img src={refLabs} alt="reflabs" />
                      </div>
                      <MyTodayAppointments />
                    </div>
                    <div className="home-col calendar-container userform_container">
                      <div className="next_app">
                        <NextAppointment />
                      </div>
                      <div className="calendar">
                        <Calendar mydate={selectedAppsDate} dates={selectedDates} />
                        <button className="homeBtn calendar-show" onClick={() => setShowAppsForm(true)} >{messages.buttons.details}</button>
                        <AddAppointmentForm show={showAppsForm} close={() => {setShowAppsForm(false)}} userId={user?.id} selectedApp={null} />
                      </div>
                    </div>
                </div>
            </>
          ) : null
        }
      </section>
    );
};

export default injectIntl(Home);
